export default __webpack_public_path__ + "向右箭头.png";